import LogotypeIcon from './LogotypeIcon'

export default LogotypeIcon
